import React from 'react'

import {
  AIGeneratedGradientFilled, Button, Icon, Tooltip,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, number, oneOfType, string } from 'prop-types'

export const EDIT_WITH_AI_LABEL = 'Edit with AI'

export const buildEditWithAiHref = itemId => `/ai?item_id=${encodeURIComponent(itemId)}`

const ICON_SIZE = { width: '16', height: '16' }

function EditWithAiAction({
  itemId,
  isDisabled = false,
  disabledMessage = '',
  tooltipId = '',
  className = '',
}) {
  const customClass = `edit-with-ai-action ${className}`.trim()
  const icon = (
    <Icon
      svgComponent={AIGeneratedGradientFilled}
      size={ICON_SIZE}
      className="edit-with-ai-action__icon"
    />
  )

  if (isDisabled) {
    const button = (
      <Button
        type="secondary"
        size="small"
        actionType="button"
        icon={icon}
        customClass={customClass}
        disabled
        aria-disabled
      >
        {EDIT_WITH_AI_LABEL}
      </Button>
    )

    return (
      <Tooltip id={tooltipId} randomizeID content={disabledMessage} place="top">
        {button}
      </Tooltip>
    )
  }

  return (
    <Button
      type="secondary"
      size="small"
      href={buildEditWithAiHref(itemId)}
      icon={icon}
      customClass={customClass}
      title={EDIT_WITH_AI_LABEL}
    >
      {EDIT_WITH_AI_LABEL}
    </Button>
  )
}

EditWithAiAction.propTypes = {
  itemId: oneOfType([number, string]).isRequired,
  isDisabled: bool,
  disabledMessage: string,
  tooltipId: string,
  className: string,
}

export default EditWithAiAction
